import { PropertyService } from './property/property.service';
import { PropertyDetailsService } from './property-details/property-details.service';
import { UsersService } from './users/users.service';
import { PersonalDetailsService } from './steps/personal-details/personal-details.service';
import { ContactInformationService } from './steps/contact-information/contact-information.service';
import { PreOrderDetailsService } from './steps/pre-order-details/pre-order-details.service';
import { PromoDiscountService } from './promo-discount/promo-discount.service';
import { FileUploadService } from './file-upload/file-upload.service';
import { WalletService } from './wallet/wallet.service';
import { OrderService } from './order/order.service';

export const Api = [
  PropertyService,
  PropertyDetailsService,
  UsersService,
  PersonalDetailsService,
  ContactInformationService,
  PreOrderDetailsService,
  PromoDiscountService,
  FileUploadService,
  WalletService,
  OrderService
];

export * from './property/property.service';
export * from './property-details/property-details.service';
export * from './users/users.service';
export * from './steps/personal-details/personal-details.service';
export * from './steps/contact-information/contact-information.service';
export * from './steps/pre-order-details/pre-order-details.service';
export * from './promo-discount/promo-discount.service';
export * from './file-upload/file-upload.service';
export * from './wallet/wallet.service';
export * from './order/order.service';
